/**
 * File navigation.js.
 */
window.addEventListener('scroll', () => {
    if (window.scrollY > 200) {
        document.body.classList.add('has-sticky-header');
        document.body.classList.remove('has-sticky-header-animate-out');
        document.body.classList.add('has-sticky-header-animate-in');
    } else {
        document.body.classList.remove('has-sticky-header-animate-in');
        document.body.classList.add('has-sticky-header-animate-out');
        document.body.classList.remove('has-sticky-header');
    }
});


document.querySelectorAll('.menu-btn').forEach((menu) => {
    menu.addEventListener('click', () => {
        document.body.classList.toggle('mobile-menu-open');
        if (document.body.classList.contains('mobile-menu-open')) {
            document.body.classList.add('mobile-menu-open--animate-open');
            setTimeout(() => {
                document.body.classList.remove('mobile-menu-open--animate-open');
            }, 1000);

        } else {
            document.body.classList.add('mobile-menu-open--animate-close');
            setTimeout(() => {
                document.body.classList.remove('mobile-menu-open--animate-close');
            }, 1000);
        }
    });
});

document.querySelectorAll('.menu-item-has-children:has(.menu-item-expand) a').forEach((item) => {
    item.addEventListener('click', (e) => {
        if (e.target.classList.contains('menu-item-expand')) {
            e.preventDefault();

            let hasExpanded = item.parentElement.classList.contains('menu-expanded')

            item.parentElement.parentElement.querySelectorAll('.menu-item-has-children:has(.menu-item-expand) a').forEach((item) => {
                item.parentElement.classList.remove('menu-expanded');
            });

            if (hasExpanded) {
                item.parentElement.classList.remove('menu-expanded');
            } else {
                item.parentElement.classList.add('menu-expanded');
            }
        }
    });
});

document.querySelectorAll('footer .col-item-mobile-expand').forEach((item) => {
    item.addEventListener('click', (e) => {
        if (e.target.classList.contains('text25')) {
            e.preventDefault();
            let hasExpanded = item.classList.contains('menu-expanded')
            if (hasExpanded) {
                item.classList.remove('menu-expanded');
            } else {
                item.classList.add('menu-expanded');
            }
        }
    });
});

document.body.addEventListener('click', function(e) {
    if ( !e.target.matches('.nav-mobile-container, .nav-mobile-container *, .main-navigation, .main-navigation *') ) {
        document.body.classList.remove('mobile-menu-open');
        document.body.classList.add('mobile-menu-open--animate-close');
        setTimeout(() => {
            document.body.classList.remove('mobile-menu-open--animate-close');
        }, 1000);
    }
});